import {LatLngExpression} from 'leaflet'

export const slottsskogenPosition: LatLngExpression = [57.686254, 11.942043]
